// @flow
import getServiceWorkerCacheData from 'app/packages/trace-logger/getServiceWorkerCacheData';
import Stopwatch from 'app/packages/trace-logger/Stopwatch';
import traceLogger from 'app/packages/trace-logger/singleton';
import { getLongTaskDurations } from 'app/packages/trace-logger/longTasks';

const cssFileMatcher = (file) => file.name.match(/\.css$/);
const jsFileMatcher = (file) => file.name.match(/\.m?js$/);
const transferSizeTotaler = (total, file) => total + file.transferSize;

export default function addPageBinaryAnnotations(currTimer: ?Stopwatch) {
  if (currTimer) {
    const timer = currTimer;
    if (traceLogger.serverTraceData.binary_annotations) {
      traceLogger.serverTraceData.binary_annotations.forEach((entry) => {
        timer.addBinaryAnnotation(entry);
      });
    }

    if (window.PerformanceObserver) {
      const longTaskDurations = getLongTaskDurations();
      if (longTaskDurations.length) {
        timer.addBinaryAnnotation({
          name: 'longTaskCount',
          value: longTaskDurations.length,
          annotation_type: 'I32',
        });
        timer.addBinaryAnnotation({
          name: 'maxLongTask',
          value: Math.max(...longTaskDurations),
          annotation_type: 'I32',
        });
      }
    }

    // Request cache hit data from the service worker
    getServiceWorkerCacheData().then((cacheData) => {
      let jsPercentFromSWCache = 0;
      let cssPercentFromSWCache = 0;
      // If no data comes back, assume SW isn't supported or is currently installing so no files came from cache
      if (cacheData) {
        const cssMissSize = cacheData.misses.filter(cssFileMatcher).reduce(transferSizeTotaler, 0);
        const jsMissSize = cacheData.misses.filter(jsFileMatcher).reduce(transferSizeTotaler, 0);
        const cssHitSize = cacheData.hits.filter(cssFileMatcher).reduce(transferSizeTotaler, 0);
        const jsHitSize = cacheData.hits.filter(jsFileMatcher).reduce(transferSizeTotaler, 0);
        if (cssHitSize) {
          cssPercentFromSWCache = cssHitSize / (cssHitSize + cssMissSize);
        }
        if (jsHitSize) {
          jsPercentFromSWCache = jsHitSize / (jsHitSize + jsMissSize);
        }
      }
      timer.addBinaryAnnotation({
        name: 'jsPercentFromSWCache',
        value: Math.round(jsPercentFromSWCache * 100),
        annotation_type: 'I32',
      });
      timer.addBinaryAnnotation({
        name: 'cssPercentFromSWCache',
        value: Math.round(cssPercentFromSWCache * 100),
        annotation_type: 'I32',
      });
    });
  }
}
